import React from 'react';
import RosterDataViewerPageContent from './RosterDataViewerPageContent';
import { RosterDataViewerPageProvider } from './RosterDataViewerPageContext';

const RosterDataViewerPage: React.FC = () => (
    <RosterDataViewerPageProvider>
      <RosterDataViewerPageContent />
    </RosterDataViewerPageProvider>
  );

export default RosterDataViewerPage;
